import TableBody from "@material-ui/core/TableBody";
import { observer } from "mobx-react";
import React from "react";
import { DataTableProps } from "./commons";
import { createHashFromMap } from "../../helpers/hash";
import { DataTableRow } from "./DataTableRow";

export const DataTableBody = observer((props: DataTableProps) => {
  const key = createHashFromMap(props.columns.Named);
  const Body = props.tableBodyComponent || TableBody;
  const Row = props.tableRowComponent || DataTableRow;

  const { tableBodyComponent, tableRowComponent, ...passThroughProps } = props;

  const bodyProps = props.tableBodyComponent ? props : {};

  return (
    <Body className={props.classes.body} {...bodyProps}>
      {props.data.map((row: any, idx: number) => {
        const extendedProps = { idx, row, ...passThroughProps };
        // @ts-ignore
        return <Row key={key + "_" + idx} {...extendedProps} />;
      })}
    </Body>
  );
});
